import Api from "../../openapi";
import useUser from "./useUser";
import { setUser } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import { setAccessToken, cleanSession } from "../../utils/tokenStore";

interface ILogin {
  email: string;
  password: string;
}

export default function useLogin() {
  const { getUser } = useUser();
  const dispatch = useDispatch();

  const login = async (credentials: ILogin) => {
    const { email, password } = credentials;
    const req = await Api.Auth.login(
      { email: String(email).trim(), password: String(password).trim() },
      { withCredentials: true },
    );
    setAccessToken(req.data.accessToken!);
    const user = await getUser();
    dispatch(setUser(user));
    return user;
  };

  const logout = async () => {
    try {
      await Api.Auth.logout();
    } catch {
      // nothing to do
    }
    cleanSession();
  };

  return { login, logout };
}
